import { DisplayState } from "@/js/app/enums";

export class PriceDisplay {
    /**
     * The state of a label that can be displayed occaisonaly (for HB mainly)
     */
    public readonly label: DisplayState;
    /**
     * The supply price display state
     */
    public readonly supply: DisplayState;
    /**
     * The drop price display state
     */
    public readonly drop: DisplayState;
    /**
     * The drop-off price display state
     */
    public readonly drop_off: DisplayState;

    constructor(label: DisplayState, supply: DisplayState, drop: DisplayState, drop_off: DisplayState) {
        this.label = label;
        this.supply = supply;
        this.drop = drop;
        this.drop_off = drop_off;
    }
}
